import React from 'react';
import {User} from '../../../../models/User';
import ChatHeader from '../../headers/Chat';
import {Container} from './styles';

interface Props {
  chatName?: string;
  user?: User;
  children: React.ReactNode
}

const ChatLayout: React.FC<Props> = ({chatName, user, children}) => {
  return (
    <>
      <ChatHeader chatName={chatName} user={user} />
      <Container>{children}</Container>
    </>
  );
};

export default ChatLayout;
